/**
 * author: Soumya Shreyas
 */
import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import { BiDotsHorizontalRounded } from "react-icons/bi";

const RecentlyCreated = () => {
  return (
    <>
      {/* <div className="row mx-0 p-1 mb-2">
        <div className="col-lg-12 py-2 px-0">
          <h5 className="m-0">Recently created</h5>
        </div>
        <div className="col-lg-12 py-2 px-0">
          <div className="RecentlyCreated_list">
            <div className="Single_RC_list">
              <table className="m-0">
              <tbody>
                <tr>
                  <td>
                    <h5 className="m-0"> Supplier Assessment 2</h5>
                    <small>Created on: 07 June, 2022 </small>
                  </td>
                  <td>
                    <h6 className="m-0">Assessment Form</h6>
                    <small>English</small>
                  </td>
                  <td>Modified on: 07 June, 2022</td>
                  <td>
                    <Badge bg="badge-red">Draft</Badge>
                  </td>
                  <td className="text-center">
                    <h6 className="m-0">5</h6>
                    <small>Questions</small>
                  </td>
                  <td>
                    <BiDotsHorizontalRounded />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div className="Single_RC_list">
              <table className="m-0">
                <tbody>
                <tr>
                  <td>
                    <h5 className="m-0"> Supplier Assessment 2</h5>
                    <small>Created on: 07 June, 2022 </small>
                  </td>
                  <td>
                    <h6 className="m-0">Assessment Form</h6>
                    <small>English</small>
                  </td>
                  <td>Modified on: 07 June, 2022</td>
                  <td>
                    <Badge bg="badge-green">Open</Badge>
                  </td>
                  <td className="text-center">
                    <h6 className="m-0">5</h6>
                    <small>Questions</small>
                  </td>
                  <td>
                    <BiDotsHorizontalRounded />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default RecentlyCreated;
